<template>
  <div>
    <h1 class="display-3">Bibliografia</h1><br/>
    <b-row>
      <b-col cols="11">
        <div class="mb-4" v-for="person in people" :key="person.id">
          <p>{{person.name}}</p>
          <ul>
            <li v-for="book in person.books">{{book}}</li>
          </ul>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import bibliografia from '@/models/historia/bibliografia'
export default {
  name: 'bibliografia',
  data: function(){
    return{
      people: bibliografia.people
    }
  },
  metaInfo:{
    title: 'Bibliografia',
    meta:[
      {name: 'description', content: '' },
      {name: 'og:url', content: 'http://akwilno.pl/historia/bibliografia' },
      {name: 'og:title', content: 'Bibliografia' },
      {name: 'og:image', content: '/main/menu_logo.png' },
      {name: 'og:description', content: '' },
      {name: 'twitter:url', content: 'http://akwilno.pl/historia/bibliografia' },
      {name: 'twitter:title', content: 'Bibliografia' },
      {name: 'witter:image', content: '/main/menu_logo.png' },
      {name: 'twitter:description', content: '' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/historia/bibliografia.vue